export function shareButtons() {
  const shareBtns = document.querySelectorAll('.share-btn');

  if (!shareBtns.length) return;

  function copyTextToClipboard(text) {
    navigator.clipboard.writeText(text).then(function() {
      console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
      console.error('Async: Could not copy text: ', err);
    });
  }

  shareBtns.forEach((shareBtn) => {

    shareBtn.addEventListener('click', function(event) {
      event.preventDefault();
      copyTextToClipboard(shareBtn.getAttribute('href'));
      shareBtn.classList.add('is-copied');
    });

  });

}